import { Method } from './utils/api-client-utils';
import ApiClientV2 from './utils/api-client-v2';

export const apiClient = new ApiClientV2({ microservice: 'billing' });
export const DEFAULT_VERSION = 1;

export const createPatientRelationship = async (
  patientId,
  patientRelationship,
) => {
  const res = await apiClient.makeRequest({
    optOutLoadingIndicator: false,
    method: Method.POST,
    path: '/api/v1/tenants/:tenantId/patients/:patientId/relationship',
    replacements: { patientId },
    body: JSON.stringify(patientRelationship),
  });

  return res;
};

export const putPatientRelationship = async (
  relationshipId,
  patientId,
  patientRelationship,
) => {
  const res = await apiClient.makeRequest({
    optOutLoadingIndicator: false,
    method: Method.PUT,
    path: '/api/v1/tenants/:tenantId/patients/:patientId/relationship/:relationshipId',
    replacements: { patientId, relationshipId },
    body: JSON.stringify(patientRelationship),
  });

  return res;
};

export const getPatientRelationships = async (
  patientId,
  queryParams = {},
  optOutLoadingIndicator = false,
) => {
  const res = await apiClient.makeRequest({
    optOutLoadingIndicator,
    method: Method.GET,
    path: '/api/v1/tenants/:tenantId/patients/:patientId/relationship',
    replacements: { patientId },
    queryParams,
  });

  return res;
};

export const getPatientRelationshipsCount = async (
  patientId,
  queryParams = {},
) => {
  const res = await apiClient.makeRequest({
    optOutLoadingIndicator: false,
    method: Method.GET,
    path: '/api/v1/tenants/:tenantId/patients/:patientId/relationship/count',
    replacements: { patientId },
    queryParams,
  });

  return res;
};

export const getPatientRelationshipsExists = async queryParams => {
  const res = await apiClient.makeRequest({
    optOutLoadingIndicator: false,
    method: Method.GET,
    path: '/api/v1/tenants/:tenantId/relationships/exists',
    queryParams,
  });

  return res;
};

export const getPatientRelationshipsActiveGroup = async patientId => {
  const res = await apiClient.makeRequest({
    optOutLoadingIndicator: false,
    method: Method.GET,
    path: '/api/v1/tenants/:tenantId/patients/:patientId/relationship/activeGroup',
    replacements: { patientId },
  });

  return res;
};

export const getPatientRelationshipsRelatedData = async ({
  patientId,
  relationTypeLabel = 'Self',
  alwaysFetchSelf = false,
}) => {
  const res = await apiClient.makeRequest({
    optOutLoadingIndicator: false,
    method: Method.GET,
    path: '/api/v1/tenants/:tenantId/patients/:patientId/relationship/related-data',
    replacements: { patientId },
    queryParams: { relationTypeLabel, alwaysFetchSelf },
  });

  return res;
};
